import { useParams } from 'react-router-dom'
import { useRepositoriesContext } from '../../../contexts/RepositoriesContext'
import { LoadingView } from '../../components/loading-view/LoadingView'
import { ComponentState, useComponentStateMachine } from '../../shared/hooks/useComponentStateMachine'
import { ErrorView } from '../../components/error-view/ErrorView'
import { useCustomerFormUpdateViewModel } from './vmHooks/useCustomerFormUpdateViewModel'
import { CustomerUpdateForm } from './component/customer-update-form.component'

export function CustomerUpdateScreen() {
  const params = useParams()
  const id = params?.customerId
  return id ? <OrganizationUpdateScreen organizationId={+id} />
    : <ErrorView />
}

export function VendorUpdateScreen() {
  const params = useParams()
  const id = params?.vendorId
  return id ? <OrganizationUpdateScreen organizationId={+id} isVendor={true} />
    : <ErrorView />
}

interface OrganizationUpdateScreenProps {
  organizationId: number
  // This flag is used to split the organization update experience in customer and vendor facing ones.
  // TODO Instead of this, it would make sense to generalize the screen to use with any organization model agnostically.
  //  Currently, the organization.isVendor fleg might be used instead.
  isVendor?: boolean
}

function OrganizationUpdateScreen({ organizationId, isVendor }: OrganizationUpdateScreenProps) {
  const { state, dataTransition } = useComponentStateMachine()
  const { organizationRepository } = useRepositoriesContext()

  // Only the organization itself gates the first paint. Every other data
  //  source (logo options, transfer options, manufacturers, users) is mounted
  //  lazily by the viewmodel when its section is first opened.
  const {
    data: organization,
    isLoading: isOrganizationLoading,
    isSuccess: isOrganizationSuccess,
    isError: isOrganizationError
  } = organizationRepository.useCustomer(organizationId)

  const vm = useCustomerFormUpdateViewModel(organization, isVendor)

  dataTransition(isOrganizationLoading, isOrganizationSuccess, isOrganizationError)
  return state === ComponentState.Succeed
    ? <CustomerUpdateForm {...vm} />
    : state === ComponentState.Loading
      ? <LoadingView />
      : <ErrorView />
}
